import React from 'react';
import { Outlet } from 'react-router-dom';
import styled from 'styled-components';

import { flexCenter } from '../../style/reusableStyle';
import Loader from '../Loader';

type Props = {
  fallback?: React.ReactNode;
  children?: React.ReactNode;
};

const ContainerStyled = styled.div`
  ${flexCenter(50)};
  width: 100%;
  height: 50vh;
`;

const ReactSuspense = ({ fallback, children }: Props) => {
  return (
    <React.Suspense
      fallback={
        fallback || (
          <ContainerStyled>
            <Loader size={'lg'} type="infinite" />
          </ContainerStyled>
        )
      }
    >
      {children || <Outlet />}
    </React.Suspense>
  );
};

export default ReactSuspense;
